import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../app/hooks";

export const removeToken = createAsyncThunk(
    "removeToken/logout",
    async (token) => {
        const response = await fetch(`${api}/admin/logout`, {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: "Bearer " + token,
            },
        });
        const result = await response.json();
        return result;
    }
);
